export class MediaStructure {
  id: string;
  fileID: string;
  CoverID?: string;
  name: string;
  originalName: string;
  extension: string;
  thumbData: string;
  previewData: string;
  type: string;
  data: string;
  appInfo: string;
  isImage?: boolean;
  isVideo?: boolean;
  isUploading: boolean;
  isError?: boolean;
  Percent?: number;
  ErrorMessage?: string;
  Position?: number;
  FileSize: number;
  width: number;
  height: number;
  mediaLink: string;
  isLink: boolean;
  isHidden: boolean;
  AltText: string;
  widthPercent: number;
  HightPercent: number;
  leftPercent: number;
  TopPercent: number;
  Roles: string[];
  mustUpdate?: boolean;
  fullPath?: string;
  isCover?: boolean;
}
export interface FileType {
  application: string;
  iconType: string;
  color: string;
}

export const FileTypesData = [
  {
    application: 'Pic',
    iconType: 'file-pdf',
    color: '#ff0e0e',
  },
  {
    application: 'pdf',
    iconType: 'file-pdf',
    color: '#ff0e0e',
  },
  {
    application: 'excel',
    iconType: 'file-excel',
    color: '#228b22',
  },
  {
    application: 'word',
    iconType: 'file-word',
    color: '#3299ff',
  },
  {
    application: 'note',
    iconType: 'file-text',
    color: '#3299ff',
  },
  {
    application: 'powerpoint',
    iconType: 'file-ppt',
    color: '#ff0e0e',
  },
  {
    application: 'zip',
    iconType: 'file-zip',
    color: '#772200',
  },
  {
    application: '',
    iconType: 'file-unknown',
    color: '#ffffff',
  },
];
export interface IMGDetails {
  url?: string;
  width?: number;
  height?: number;
  base64Img?: string;
}
export interface Thumbnails {
  default: IMGDetails;
  medium: IMGDetails;
  high: IMGDetails;
  standard: IMGDetails;
  maxres: IMGDetails;
}
export interface Localized {
  title: string;
  description: string;
}
export interface Snippet {
  publishedAt: Date;
  channelId: string;
  title: string;
  description: string;
  thumbnails: Thumbnails;
  channelTitle: string;
  tags: string[];
  categoryId: string;
  liveBroadcastContent: string;
  localized: Localized;
}
export interface ContentDetails {
  duration: string;
  dimension: string;
  definition: string;
  caption: string;
  licensedContent: boolean;
  projection: string;
}
export interface Status {
  uploadStatus: string;
  privacyStatus: string;
  license: string;
  embeddable: boolean;
  publicStatsViewable: boolean;
  madeForKids: boolean;
}
export interface Statistics {
  viewCount: string;
  likeCount: string;
  dislikeCount: string;
  favoriteCount: string;
  commentCount: string;
}
export interface Item {
  kind: string;
  etag: string;
  id: string;
  snippet: Snippet;
  contentDetails: ContentDetails;
  status: Status;
  statistics: Status;
}
export interface PageInfo {
  totalResults: number;
  resultsPerPage: number;
}
export interface YoutubeResult {
  kind: string;
  etag: string;
  items: Item[];
  pageInfo: PageInfo;
}
export interface MediaObject {
  id: number;
  fileId: number;
  fileName: string;
  fileExtension: string;
  fullPath: string;
  data: string;
  type: string;
  appInfo: string;
  md5: string;
  postion: number;
  fileSize: number;
  width: number;
  height: number;
  mediaLink: string;
  isLink: boolean;
  isHidden: boolean;
  altText: string;
  roles: string;
  coverID: number;
  isVideo: boolean;
}
export interface MediaObject {
  id: number;
  fileId: number;
  fileName: string;
  fileExtension: string;
  fullPath: string;
  data: string;
  type: string;
  appInfo: string;
  md5: string;
  postion: number;
  fileSize: number;
  width: number;
  height: number;
  mediaLink: string;
  isLink: boolean;
  isHidden: boolean;
  altText: string;
  roles: string;
  coverID: number;
  isVideo: boolean;
}
